import { NB_PROMO_OFFERS_SELECTION_DESKTOP, NB_PROMO_OFFERS_SELECTION_MOBILE } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';

export function isDesktopExperimentEnabled({ experiments }: IApplicationState) {
  const experiment = experiments.find(e => e.experimentName === NB_PROMO_OFFERS_SELECTION_DESKTOP);

  if (!experiment) {
    return false;
  }

  return experiment.groupName === 'B';
}

export function isMobileExperimentEnabled({ experiments }: IApplicationState) {
  const experiment = experiments.find(e => e.experimentName === NB_PROMO_OFFERS_SELECTION_MOBILE);

  if (!experiment) {
    return false;
  }

  return experiment.groupName === 'B';
}
